export default __webpack_public_path__ + "static/3-92accf9d58e36d66f886d89bb67603d3.jpeg";